import { render } from "./emission_new.vue?vue&type=template&id=c503381a&scoped=true"
import script from "./emission_new.vue?vue&type=script&lang=js"
export * from "./emission_new.vue?vue&type=script&lang=js"

import "./emission_new.vue?vue&type=style&index=0&id=c503381a&lang=scss&scoped=scoped"
import "./emission_new.vue?vue&type=style&index=1&id=c503381a&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c503381a"]])

export default __exports__